import React, { useState } from "react";
import BankForm from "./BankForm";

export default function BankTab({
  banks,
  onAdd,
  onUpdate,
  onRemove,
  onSetDefault,
}) {
  const [editingIndex, setEditingIndex] =
    useState(null);

  return (
    <div className="erp-section">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 10,
        }}
      >
        <div className="erp-section-title">
          Bank Accounts
        </div>

        <button
          className="btn btn-sm btn-primary"
          onClick={() => setEditingIndex(-1)}
        >
          + Add Bank
        </button>
      </div>

      {editingIndex !== null && (
        <BankForm
          initialData={
            editingIndex >= 0
              ? banks[editingIndex]
              : null
          }
          onCancel={() => setEditingIndex(null)}
          onSave={(data) => {
            if (editingIndex >= 0) {
              onUpdate(editingIndex, data);
            } else {
              onAdd(data);
            }
            setEditingIndex(null);
          }}
        />
      )}

      <table className="table table-bordered">
        <thead className="table-light">
          <tr>
            <th>Bank</th>
            <th>Account No</th>
            <th>IFSC</th>
            <th>Default</th>
            <th width="140">Action</th>
          </tr>
        </thead>

        <tbody>
          {banks.length === 0 && (
            <tr>
              <td
                colSpan={5}
                className="text-center text-muted"
              >
                No bank accounts added
              </td>
            </tr>
          )}

          {banks.map((b, i) => (
            <tr key={i}>
              <td>{b.bank_name}</td>
              <td>{b.account_number}</td>
              <td>{b.ifsc}</td>
              <td>{b.is_default ? "✔" : ""}</td>
              <td>
                <button
                  className="btn btn-sm btn-outline-primary me-2"
                  onClick={() =>
                    setEditingIndex(i)
                  }
                >
                  Edit
                </button>

                <button
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => onRemove(i)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
